<template>
    <v-container>
      <v-card class="mx-auto pa-4" v-if="this.catCode != null">
        <p class="display-1 text--primary">
            <v-icon>developer_board</v-icon>
            {{ this.catCode.catCodeString }} : {{ this.catCode.catCodeDesc }}
        </p>
        <v-expansion-panels >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    eBay query parameters
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-container>
                    <v-row no-gutters>
                        <v-col cols="2">
                            Words To Include:
                        </v-col>
                        <v-col>
                            {{ this.catCode.wordsToInclude }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            Words To Exclude:
                        </v-col>
                        <v-col>
                            {{ this.catCode.wordsToExclude }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            Days between scans:
                        </v-col>
                        <v-col>
                            {{ this.catCode.daysBetweenScans }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            Refined Min Qty:
                        </v-col>
                        <v-col>
                            {{ this.catCode.refinedMinQty }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            Qty Cap:
                        </v-col>
                        <v-col>
                            {{ this.catCode.qtyCap  }}
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="2">
                            Min Qty to Scan:
                        </v-col>
                        <v-col>
                            {{ this.catCode.minQtyToScan }}
                        </v-col>
                    </v-row>
                </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-container>
</template>


<script>
    import {CatCodesService} from '../../services/api/catCodes';
    const apiCatCodes = new CatCodesService();

export default {
    props: {
        title: String,
        catCodeString: String,
    },
    
    data () {
      return {
          catCode : null,
      }
    },

    created () {
        // Load the Cat Code from the CatCodeString
        apiCatCodes.getCatCodeByString(this.catCodeString).then((data) => {
            this.catCode = data
        });
      
        // Listen to status changes coming from SignalR events
        //this.$scannerHub.$on('scan-completed', this.onScanCompleted)
    },
}
</script>